import { useState } from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import WhatsAppFAB from "@/components/WhatsAppFAB";
import { Search, Clock, Truck, CheckCircle2, XCircle } from "lucide-react";

const ICONS = {
  scheduled: Clock,
  out_for_delivery: Truck,
  delivered: CheckCircle2,
  missed: XCircle,
};

const MOCK_TIMELINE = [
  { status: "scheduled", time: "Yesterday · 9:00 PM", text: "Order scheduled for tomorrow morning" },
  { status: "out_for_delivery", time: "Today · 5:30 AM", text: "Fresh milk picked up from farm" },
  { status: "out_for_delivery", time: "Today · 6:45 AM", text: "Out for delivery with Ramesh (delivery partner)" },
  { status: "delivered", time: "Today · 7:12 AM", text: "Delivered at your doorstep · Sealed packet" },
];

export default function Track() {
  const [orderId, setOrderId] = useState("");
  const [found, setFound] = useState(false);

  return (
    <div className="bg-dd-page min-h-screen" data-testid="track-page">
      <Navbar />
      <div className="pt-28 dd-container max-w-3xl pb-20">
        <div className="dd-label text-dd-gold-dark mb-2">Delivery Tracker</div>
        <h1 className="font-serif text-4xl md:text-5xl text-dd-ink">Where's my milk?</h1>
        <p className="mt-2 text-dd-ink-muted">Enter your order ID (or phone number) to see live status.</p>

        <div className="mt-8 flex gap-3">
          <div className="flex-1 flex items-center gap-3 bg-white border border-dd-line rounded-sm px-4 focus-within:border-dd-green focus-within:ring-1 focus-within:ring-dd-green">
            <Search className="w-5 h-5 text-dd-green" strokeWidth={1.5} />
            <input value={orderId} onChange={(e) => setOrderId(e.target.value)} placeholder="DD-ORDER-12345 or +91 phone"
              className="w-full py-3.5 bg-transparent outline-none text-dd-ink" data-testid="track-input" />
          </div>
          <button onClick={() => setFound(orderId.length > 2)} className="bg-dd-green text-dd-page px-6 py-3.5 rounded-sm font-medium" data-testid="track-btn">
            Track
          </button>
        </div>

        {found && (
          <div className="mt-10 bg-white border border-dd-line rounded-sm p-7" data-testid="track-result">
            <div className="flex items-center justify-between">
              <div>
                <div className="dd-label text-dd-gold-dark">Order</div>
                <div className="font-serif text-2xl text-dd-ink">{orderId || "DD-ORDER-12345"}</div>
              </div>
              <span className="text-xs uppercase tracking-wider px-2.5 py-1 rounded-sm bg-dd-green text-dd-page">Delivered</span>
            </div>

            <ol className="mt-7 space-y-5 border-l border-dd-line pl-6 relative">
              {MOCK_TIMELINE.map((step, i) => {
                const Icon = ICONS[step.status];
                return (
                  <li key={i} className="relative">
                    <span className="absolute -left-9 w-5 h-5 rounded-full bg-dd-green text-dd-page flex items-center justify-center">
                      <Icon className="w-3 h-3" strokeWidth={2} />
                    </span>
                    <div className="text-sm text-dd-ink-muted">{step.time}</div>
                    <div className="font-medium text-dd-ink">{step.text}</div>
                  </li>
                );
              })}
            </ol>
          </div>
        )}
      </div>
      <Footer />
      <WhatsAppFAB />
    </div>
  );
}
